import { jsx as _jsx } from "react/jsx-runtime";
import { IconListEntry } from './IconListEntry.js';
import { CharacterImageVariant, ImageContainerShape, renderCharacterImage } from './image/index.js';
export function CharacterListEntry(props) {
    const { character, onClick, button, dense } = props;
    const characterImage = renderCharacterImage(character, {
        maxHeightInPixels: 45,
        maxWidthInPixels: 45,
        containerShape: ImageContainerShape.Circle,
        variant: CharacterImageVariant.Profile,
        backgroundColor: 'white',
    });
    return (_jsx(IconListEntry, { icon: characterImage, primaryText: character.name, onClick: onClick, button: button, dense: dense }));
}
//# sourceMappingURL=CharacterListEntry.js.map